(() => {
  'use strict';
  const hint = document.currentScript?.dataset.termsHint;
  // Provider checkout controls are links/buttons, so native required-field feedback may be invisible.
  document.addEventListener('click', event => {
    const checkout = event.target.closest?.('.xcotton-checkout, [name="checkout"]');
    const form = checkout?.closest('form');
    const terms = form?.querySelector('input[type="checkbox"][name="terms"][required]');
    if (!terms || terms.checked) return;

    event.preventDefault();
    event.stopPropagation();
    let note = form.querySelector('[data-sp-terms-hint]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.spTermsHint = '';
      note.id = terms.id + '-hint';
      note.setAttribute('role', 'alert');
      note.style.cssText = 'margin:8px 0 12px;color:#842f22;font:inherit';
      const label = form.querySelector('label[for="' + CSS.escape(terms.id) + '"]');
      (label || terms).after(note);
      terms.setAttribute('aria-describedby', [terms.getAttribute('aria-describedby'), note.id].filter(Boolean).join(' '));
      terms.addEventListener('change', () => {
        if (terms.checked) {
          note.hidden = true;
          terms.removeAttribute('aria-invalid');
        }
      });
    }
    note.hidden = false;
    note.textContent = hint || terms.validationMessage;
    terms.setAttribute('aria-invalid', 'true');
    terms.focus({preventScroll: true});
    terms.scrollIntoView({block: 'center', behavior: 'instant'});
  }, true);
})();
